import React from 'react'
import { G, Line, Polygon } from 'react-native-svg'
import { computeArrowGeometry, sourceArrowInset, targetArrowInset, type Point } from '../../lib/arrowGeometry'

/** Teal: the fortify trail colour (live animation and snapshots). */
export const FORTIFY_ARROW_COLOR = '#0891B2'

interface DirectionArrowProps {
  from: Point
  to: Point
  badgeRadius: number
  trailWidth: number
  /** Shaft and head colour; defaults to the fortify teal. Attack snapshots pass red. */
  color?: string
  testID?: string
}

/** Static from→to arrow shared by reduced-motion fortify results and event snapshots. */
export function DirectionArrow({ from, to, badgeRadius, trailWidth, color = FORTIFY_ARROW_COLOR, testID }: DirectionArrowProps) {
  if (from.x === to.x && from.y === to.y) return null
  // Both ends sit just inside the badge circles, clear of the digits; the
  // geometry shrinks the gap and head on short hops so a tail always shows.
  const arrow = computeArrowGeometry(from, to, targetArrowInset(badgeRadius), trailWidth * 4, sourceArrowInset(badgeRadius))
  return (
    <G testID={testID} pointerEvents="none">
      <Line x1={arrow.shaftFrom.x} y1={arrow.shaftFrom.y} x2={arrow.shaftTo.x} y2={arrow.shaftTo.y}
        stroke="#ffffff" strokeWidth={trailWidth * 1.8} strokeOpacity={0.4}
        strokeLinecap="round" pointerEvents="none" />
      <Line x1={arrow.shaftFrom.x} y1={arrow.shaftFrom.y} x2={arrow.shaftTo.x} y2={arrow.shaftTo.y}
        stroke={color} strokeWidth={trailWidth} strokeOpacity={0.7}
        strokeLinecap="round" pointerEvents="none" />
      <Polygon points={arrow.arrowPoints} fill={color} stroke="#ffffff"
        strokeWidth={trailWidth * 0.6} strokeLinejoin="round" pointerEvents="none" />
    </G>
  )
}
